import type { ComponentType } from 'react';
import { PAYMENT_TRANSACTION_TYPE, type PaymentTransactionType } from '../../../types/enums';
import FinpspDepositForm from './FinpspDepositForm';
import FinpspWithdrawForm from './FinpspWithdrawForm';

export type FinpspFormProps = {
  paymentProvider: string | null;
};

export const FINPSP_FORMS: Record<PaymentTransactionType, ComponentType<FinpspFormProps>> = {
  [PAYMENT_TRANSACTION_TYPE.DEPOSIT]: FinpspDepositForm,
  [PAYMENT_TRANSACTION_TYPE.WITHDRAW]: FinpspWithdrawForm,
};
